const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20colorful%20manga%20panel%20style%20illustration%20showing%20intense%20romantic%20drama%20scene%20between%20two%20characters%20in%20modern%20Korean%20webtoon%20style%2C%20soft%20warm%20lighting%20with%20pink%20and%20peach%20tones%2C%20dramatic%20composition%20with%20close%20up%20expressions%2C%20beautiful%20detailed%20background%20with%20cherry%20blossoms%2C%20clean%20polished%20artwork&width=600&height=400&seq=media-manga-01&orientation=landscape',
    tag: '韩漫精选',
    title: '《社内恋爱法则》',
    desc: '职场恋爱天花板，甜蜜与心动并存',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20manga%20scene%20with%20powerful%20martial%20arts%20character%20in%20dynamic%20fighting%20pose%20surrounded%20by%20energy%20effects%2C%20Chinese%20manhua%20style%20with%20detailed%20costumes%20and%20flowing%20fabrics%2C%20dramatic%20lighting%20with%20warm%20golden%20and%20red%20tones%2C%20intricate%20background%20with%20ancient%20palace%20architecture%2C%20high%20quality%20illustration&width=600&height=400&seq=media-manga-02&orientation=landscape',
    tag: '国漫推荐',
    title: '《重生之都市仙尊》',
    desc: '修仙归来，都市无敌爽文漫改',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20manga%20scene%20with%20young%20hero%20and%20magical%20creatures%20in%20a%20mystical%20forest%20setting%2C%20Japanese%20shonen%20manga%20style%20with%20bold%20lines%20and%20vibrant%20colors%2C%20dynamic%20action%20composition%20with%20speed%20lines%2C%20warm%20sunlight%20filtering%20through%20trees%2C%20detailed%20character%20designs%20with%20expressive%20faces&width=600&height=400&seq=media-manga-03&orientation=landscape',
    tag: '日漫经典',
    title: '《咒术学院》',
    desc: '超人气热血战斗，高燃不断',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精彩推荐</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑精选优质漫画，本本都是高分佳作
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all">
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`汗汗漫画 ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-950/60 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg text-foreground-950 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-600">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}